<template>
    <Row class="ly-title" :class="{'ly-title__absolute': attrs.fixed}">
        <Col span="4">
            <label>{{attrs.title}}</label>
        </Col>
        <Col span="20">
            <template v-for="el in attrs.children">
                 <ly-hoc :attrs="el" :power="power"></ly-hoc>
            </template>
        </Col>
    </Row>
</template>
<script>
    export default {
        name: 'LyTitle',
        props: {
            power: { // 2020-08-03 by zjs 增加权限的识别
                type: [Array, Object, Boolean],
                default: _ => new Array()
            },
            attrs: {
                type: Object,
                default: _ => new Object()
            }
        },
        mounted () {
            // 开启了吸顶效果
            if (this.attrs.fixed) {
                // 为main点加入padding-top
                // flex-main是快捷审核组件中的
                let main =  document.getElementById('flex-main') || document.getElementById('main')
                main.style.paddingTop = this.$el.clientHeight - 20 + 'px'
                // 实际滚动的容器组件
                // flex-layout-content是快捷审核组件中的
                let layout = document.getElementById('flex-layout-content') || document.getElementById('layout-content')
                layout.removeEventListener('scroll', this.layoutScroll)
                layout.addEventListener('scroll', this.layoutScroll)
            }
        },
        methods: {
            /**
             * 布局容器的滚动
             */
            layoutScroll (e) {
                this.$el.style.top =  e.target.scrollTop - 20 + 'px'
            }
        }
    }
</script>
<style>
    .ly-title {
        padding: 0 1px;
       
    }
    .ly-title__absolute {
        position: absolute;
        top: -20px;
        left: -20px;
        right: -20px;
        padding: 20px;
        background-color: #fff;
        z-index: 10;
        box-shadow: 0 2px 5px rgba(0, 0, 0, .1);
    }
    .ly-title label {
        font-weight: bold;
        line-height: 32px;
    }
    .ly-title .ivu-col-span-20 {
        text-align: right;
    }
    .ly-title .ivu-btn {
        margin-left: 5px;
    }
</style>


// WEBPACK FOOTER //
// ../projectCore/src/components/title/src/index.vue